import React from 'react';

interface Props {
    icon: React.ReactNode;
    label: string;
    isActive?: boolean;
    /** Renders the icon inert and muted rather than removing it from the rail. */
    isDisabled?: boolean;
    onClick: () => void;
}

// One 32x32 icon slot in the Navbar V2 rail. Icons draw with `currentColor`, so the active
// pill only has to swap the text colour.
function NavRailButton({ icon, label, isActive = false, isDisabled = false, onClick }: Props) {
    const getStateClassName = () => {
        if (isDisabled) return 'cursor-not-allowed text-filterV2IconMuted';
        if (isActive) return 'bg-filterV2PrimaryBg text-filterV2Primary';
        return 'text-purpleFont hover:bg-filterV2PrimaryBg';
    };

    return (
        <button
            type="button"
            aria-label={label}
            title={label}
            aria-pressed={isActive}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            onClick={onClick}
            className={`flex h-8 w-8 items-center justify-center rounded-lg transition-colors ${getStateClassName()}`}
        >
            {icon}
        </button>
    );
}

export default NavRailButton;
